import React, { Component } from 'react';
import { Col, Row, Tab, Nav, NavItem } from 'react-bootstrap';
import { connect } from 'react-redux';
import { chapterSelector, dkpSelector } from '../redux/selectors'
import { openChapters, toArray } from '../common/util';
import { fetchSections } from '../redux/actions';
import DKPStanding from './DKPStanding';
import DKPEvents from './DKPEvents';
import DKPItems from './DKPItems';
import DKPResources from './DKPResources';

class DKP extends Component {
    componentDidMount() {
        document.title = "Addiction | DKP | Standings";
        openChapters(this.props.chapters)
            .filter(chapter => chapter.game.title !== "Addiction")
            .map((chapter) => {
                this.props.getSections(chapter.id);
                return null;
            });
    }

    render() {
        // Set the defaultActiveKey for the tabs based on url location
        let location = this.props.location.pathname.split('/');
        location = location[location.length -1];
        if (location === '') {
            location = 'standings'
        }
        return (
            <div>
                <h1>DKP</h1>
                <div className="panel">
                    <Tab.Container id="dkp" defaultActiveKey="0-chapter">
                        <Row className="clearfix">
                            <Col xs={18} md={12}>
                                <Nav bsStyle="pills">
                                {
                                    openChapters(this.props.chapters)
                                        .filter(chapter => chapter.game.title !== "Addiction")
                                        .sort((a, b) => (new Date(b.openDate).getTime() - new Date(a.openDate).getTime()))
                                        .filter(chapter => toArray(this.props.dkp.data).map((dkp) => { return dkp.chapter}).includes(chapter.id))
                                        .map((chapter, i) => (
                                        <NavItem eventKey={`${i}-chapter`} key={`${i}-chapter`}>
                                                <h3>{chapter.game.title} </h3>
                                        </NavItem>
                                    ))
                                }
                                </Nav>
                            </Col>
                            <Col xs={18} md={12}>
                                <Tab.Content animation>
                                    { openChapters(this.props.chapters)
                                        .filter(chapter => chapter.game.title !== "Addiction")
                                        .sort((a, b) => (new Date(b.openDate).getTime() - new Date(a.openDate).getTime()))
                                        .filter(chapter => toArray(this.props.dkp.data).map((dkp) => { return dkp.chapter}).includes(chapter.id))
                                        .map((chapter, i) => (
                                        <Tab.Pane eventKey={`${i}-chapter`} key={`${i}-chapter`}>
                                            <Tab.Container id="details" defaultActiveKey={location}>
                                                <Row className="clearfix">
                                                    <Col xs={18} md={12}>
                                                        <Nav bsStyle="pills">
                                                            <NavItem eventKey="standings">
                                                                <h3>Standings</h3>
                                                            </NavItem>
                                                            <NavItem eventKey="events">
                                                                <h3>Event History</h3>
                                                            </NavItem>
                                                            <NavItem eventKey="items">
                                                                <h3>Item History</h3>
                                                            </NavItem>
                                                            <NavItem eventKey="resources">
                                                                <h3>Resources</h3>
                                                            </NavItem>
                                                        </Nav>
                                                    </Col>
                                                    <Col xs={18} md={12}>
                                                        <Tab.Content animation>
                                                            <Tab.Pane eventKey="standings">

                                                                <Tab.Container id="section-standings" defaultActiveKey="0-section-standings">
                                                                    <Row className="clearfix">
                                                                        <Col xs={18} md={12}>
                                                                            <Nav bsStyle="pills">
                                                                                { toArray(this.props.dkp.data).filter(dkp => dkp.chapter === chapter.id)
                                                                                    .map((dkp, i) => (
                                                                                        <NavItem eventKey={`${i}-section-standings`} key={`${i}-section-standings`}>
                                                                                            <h3>{dkp.title}</h3>
                                                                                        </NavItem>
                                                                                    ))
                                                                                }
                                                                            </Nav>
                                                                        </Col>
                                                                        <Col xs={18} md={12}>
                                                                            <Tab.Content animation>
                                                                                { toArray(this.props.dkp.data).filter(dkp => dkp.chapter === chapter.id)
                                                                                    .map((dkp, i) => (
                                                                                        <Tab.Pane eventKey={`${i}-section-standings`} key={`${i}-section-standings`}>
                                                                                            <DKPStanding dkp={this.props.dkp} section={dkp} />
                                                                                        </Tab.Pane>
                                                                                    ))
                                                                                }
                                                                            </Tab.Content>
                                                                        </Col>
                                                                    </Row>
                                                                </Tab.Container>
                                                            </Tab.Pane>
                                                            <Tab.Pane eventKey="events">
                                                                <Tab.Container id="section-events" defaultActiveKey="0-section-events">
                                                                    <Row className="clearfix">
                                                                        <Col xs={18} md={12}>
                                                                            <Nav bsStyle="pills">
                                                                                { toArray(this.props.dkp.data).filter(dkp => dkp.chapter === chapter.id)
                                                                                    .map((dkp, i) => (
                                                                                        <NavItem eventKey={`${i}-section-events`} key={`${i}-section-events`}>
                                                                                            <h3>{dkp.title}</h3>
                                                                                        </NavItem>
                                                                                    ))
                                                                                }
                                                                            </Nav>
                                                                        </Col>
                                                                        <Col xs={18} md={12}>
                                                                            <Tab.Content animation>
                                                                                { toArray(this.props.dkp.data).filter(dkp => dkp.chapter === chapter.id)
                                                                                    .map((dkp, i) => (
                                                                                        <Tab.Pane eventKey={`${i}-section-events`} key={`${i}-section-events`}>
                                                                                             <DKPEvents dkp={this.props.dkp} section={dkp} />
                                                                                        </Tab.Pane>
                                                                                    ))
                                                                                }
                                                                            </Tab.Content>
                                                                        </Col>
                                                                    </Row>
                                                                </Tab.Container>
                                                            </Tab.Pane>
                                                            <Tab.Pane eventKey="items">
                                                                <DKPItems chapter={chapter} />
                                                            </Tab.Pane>
                                                            <Tab.Pane eventKey="resources">
                                                                
                                                                <Tab.Container id="section-resources" defaultActiveKey="0-section-resources">
                                                                    <Row className="clearfix">
                                                                        <Col xs={18} md={12}>
                                                                            <Nav bsStyle="pills">
                                                                                { toArray(this.props.dkp.data).filter(dkp => dkp.chapter === chapter.id)
                                                                                    .map((dkp, i) => (
                                                                                        <NavItem eventKey={`${i}-section-resources`} key={`${i}-section-resources`}>
                                                                                            <h3>{dkp.title}</h3>
                                                                                        </NavItem>
                                                                                    ))
                                                                                }
                                                                            </Nav>
                                                                        </Col>
                                                                        <Col xs={18} md={12}>
                                                                            <Tab.Content animation>
                                                                                { toArray(this.props.dkp.data).filter(dkp => dkp.chapter === chapter.id)
                                                                                    .map((dkp, i) => (
                                                                                        <Tab.Pane eventKey={`${i}-section-resources`} key={`${i}-section-resources`}>
                                                                                             <DKPResources chapter={chapter} dkp={dkp} />
                                                                                        </Tab.Pane>
                                                                                    ))
                                                                                }
                                                                            </Tab.Content>
                                                                        </Col>
                                                                    </Row>
                                                                </Tab.Container>
                                                            </Tab.Pane>
                                                        </Tab.Content>
                                                    </Col>
                                                </Row>
                                            </Tab.Container>
                                        </Tab.Pane>
                                    ))}
                                </Tab.Content>
                            </Col>
                        </Row>
                    </Tab.Container>
                </div>
            </div>
        )

    }
}

const mapStateToProps = (state) => ({
    chapters: chapterSelector(state),
    dkp: dkpSelector(state),
});

const mapDispatchToProps = (dispatch) => ({
     getSections: (chapter) => dispatch(fetchSections(chapter)),
});

export default connect(mapStateToProps, mapDispatchToProps)(DKP);


// WEBPACK FOOTER //
// ./src/DKP/DKP.js